"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const link_helpers_1 = require("./link_helpers");
function makeTitle(link) {
  if (!link.title) {
    return '';
  } else if ((0, link_helpers_1.isPhoto)(link) && (0, link_helpers_1.isStatic)(link)) {
    return '';
  } else if (!!link.extension && link.title.toLowerCase().endsWith(`.${link.extension.toLowerCase()}`)) {
    // If the file is, say, a pdf and the title is Filename.pdf, remove .pdf from the title.
    return link.title.replace(new RegExp(`.${link.extension}$`, 'i'), '').replace(/\_/g, ' ').replace(/\s+/g, ' ');
  }
  return link.title;
}
exports.default = makeTitle;